import { Component, OnInit, OnDestroy, effect, untracked } from '@angular/core';
import { PlacesStore } from '../../stores/places.store';
import { DATETIMEFORMART } from 'src/app/interfaces/interfaces';
import * as moment from 'moment';
import { DatetimeFormatService } from 'src/app/services/datetime-format-service/datetime-format.service';
import { Subscription } from 'rxjs';
import { StringInfoMessageService } from 'src/app/services/string-info-message/string-info-message.service';

@Component({
  selector: 'app-active-search-request-preview',
  templateUrl: './active-search-request-preview.component.html',
  styleUrls: ['./active-search-request-preview.component.scss'],
})
export class ActiveSearchRequestPreviewComponent implements OnInit, OnDestroy {
  isStartTimeModalOpen: boolean = false;
  isEndTimeModalOpen: boolean = false;
  locale = this.dateTimeFormatService.selectedDateTimeFormat;
  private subscription: Subscription;
  
  // Local time values that will be updated when search request changes
  localStartTime: string | null = null;
  localEndTime: string | null = null;
  seriesMessage: string | null = null;
  minimumDateForStartTimeChip = moment().format(DATETIMEFORMART)

  get updateEndTimeDatePickerMinimumValue() {
    return moment(this.localStartTime).add(5, 'minutes').format(DATETIMEFORMART);
  }

  get searchRequestType() {
    return this.placesStore.searchRequestType();
  }


  resetFilter() {
    this.placesStore.setSearchRequest(null);
  }

  
  constructor(public placesStore: PlacesStore, private dateTimeFormatService: DatetimeFormatService, public stringInfoMessageService: StringInfoMessageService) { 
    // Effect to update local time values/series message when search request changes
    effect(() => {
      if(this.searchRequestType == 'single') {
        this.localStartTime = moment(this.placesStore.searchRequest()?.startTime).format(DATETIMEFORMART);
        this.localEndTime = moment(this.placesStore.searchRequest()?.endTime).format(DATETIMEFORMART);
      } else if (this.searchRequestType == 'series') {
        this.seriesMessage = this.stringInfoMessageService.seriesEventInformationMessage(this.placesStore.searchRequest()?.recurrencePattern, true);
      }
    });
  }

  ngOnInit() {
    // this.subscription = this.dateTimeFormatService.selectedDateTimeFormat$.subscribe(format => {
    //   this.locale = format;
    // });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe
    }
  }


  openStartDateTimeModal() {
    this.isStartTimeModalOpen = true;
  }

  openEndDateTimeModal() {
    this.isEndTimeModalOpen = true;
  }


  handlePopOverDissmiss() {
    this.isStartTimeModalOpen = false;
    this.isEndTimeModalOpen = false;
    this.placesStore.setSearchRequest({
        ...this.placesStore.searchRequest(),
      startTime: moment(this.localStartTime).utc().toDate(),
      endTime: moment(this.localEndTime).utc().toDate()
    });
  }

  handleSearchStartTimeChange(event: any) {
    this.localStartTime = event.detail.value;
    this.localEndTime = moment(this.localStartTime).add(1, 'hours').format(DATETIMEFORMART);
  }

  handleSearchEndTimeChange(event: any) {
    this.localEndTime = event.detail.value;
  }
  
 
}
